import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/apiClient";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, role) => {
    const { data } = await api.post("/auth/login", { email, password, role });
    if (data.token) localStorage.setItem("dt_token", data.token);
    setUser(data);
    return data;
  };

  const socialLogin = async ({ provider, email, name, picture, provider_user_id, id_token }) => {
    const { data } = await api.post("/auth/social", { provider, email, name, picture, provider_user_id, id_token });
    if (data.token) localStorage.setItem("dt_token", data.token);
    setUser(data);
    return data;
  };

  // The end of a Google/Facebook redirect sign-in: the backend has already set the session cookie,
  // this picks up the user and the token copy the rest of the app reads from localStorage.
  const completeRedirectSignIn = async () => {
    const { data } = await api.post("/auth/session");
    if (data.token) localStorage.setItem("dt_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("dt_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, socialLogin, completeRedirectSignIn, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
